<template>
  <Card v-if="article" :blok="makeCard()" />
</template>

<script lang="ts" setup>
import { useStoriesStore } from '@/stores/Stories';

const store = useStoriesStore();
await store.fetchData();

// Props
const props = defineProps<{
  id: string;
}>();

const article = store.getStoryById(props.id);

const imageDimensions = {
  height: 533,
  width: 400,
};

const makeCard = () => {
  if (article) {
    return {
      link: [
        {
          aria_label: `Read more about ${article.name}`,
          display_name: 'Read More',
          link: {
            cached_url: article.full_slug,
          },
          style: 'tertiary',
        },
      ],
      media: [
        {
          component: 'LayeredPicture',
          image:
            article.content.preview_image?.filename !== ''
              ? {
                  ...article.content.preview_image,
                  ...imageDimensions,
                }
              : {
                  ...article.content.hero_image,
                  ...imageDimensions,
                },
        },
      ],
      text: [
        {
          eyebrow: article.content.topic,
          heading: [
            {
              heading_style: 'text-4',
              heading_text: {
                content: [
                  {
                    content: [
                      {
                        text: article.name,
                        type: 'text',
                      },
                    ],
                    type: 'paragraph',
                  },
                ],
                type: 'doc',
              },
              heading_type: 'h4',
            },
          ],
          text: {
            content: [
              {
                content: [
                  {
                    text: article.content.summary,
                    type: 'text',
                  },
                ],
                type: 'paragraph',
              },
            ],
            type: 'doc',
          },
        },
      ],
    };
  }
};
</script>
